import Vue from "vue";
import Vuex from "vuex";
import { setItems, getItems } from "@/assets/js/common";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo:getItems("userInfo"),// 个人信息
    getDateList: getItems("getDateList"), // 库存日历
    selectedDate: getItems("selectedDate"), // 当前选中的日期
    ticketedArr: getItems("ticketedArr"), // 普通票 添加
    orderDetails:null,
    openId:null,
    loginToken:"",
    orderInfo:getItems("orderInfo"),
    contactsInfo:getItems("contactsInfo"),
    selectedTick:getItems("selectedTick")
  },
  mutations: {
    getDateList(state, payload) {
      setItems("getDateList", payload);
      state.getDateList = payload;
    },
    selectedDate(state, payload) {
      setItems("selectedDate", payload);
      state.selectedDate = payload;
    },
    ticketedArr(state, payload) {
      setItems("ticketedArr", payload);
      state.ticketedArr = payload;
    },
    orderDetails(state,payload){
      state.orderDetails = payload;
    },
    userInfo(state,payload){
      setItems("userInfo", payload);
      state.userInfo = payload;
    },
    openId(state,payload){
      state.openId = payload;
    },
    loginToken(state,payload){
      // setItems("loginToken", payload);
      state.loginToken = payload;
    },
    orderInfo(state,payload){
      setItems("orderInfo", payload);
      state.orderInfo = payload;
    },
    contactsInfo(state,payload){
      setItems("contactsInfo",payload);
      state.contactsInfo = payload
    },
    selectedTick(state,payload){
      setItems("selectedTick",payload);
      state.selectedTick = payload;
    }
  },
  actions: {},
  modules: {},
});
